const routes = [
    {
        path: "/ferpa-consent-release-form",
        component: () => import("../pages/Index"),
        meta: {
           isStudent:true,
            isAuthenticated: true,

        }
    }
];

export default routes;
